// src/components/AboutSection.js
import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './AboutSection.css';

function AboutSection() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="about-section">
      <div className="floating-bg-shape shape1" />
      <div className="floating-bg-shape shape2" />
      <Container>
        <h2 className="section-title" data-aos="fade-up"> About The Tathastu Education</h2>
        <Row className="align-items-center">
          <Col md={5} data-aos="fade-right">
            <img
              src="/Images/founder-image1.png" // replace with actual image path
              alt="Amod Kumar Sharma"
              className="founder-image"
            />
          </Col>
          <Col md={7} data-aos="fade-left">
            <p className="about-text">
              <strong>Tathastu Education</strong> is a mission-driven initiative to make school education more impactful by integrating counselling, digital branding, and academic mentoring. Founded by <strong>Amod Kumar Sharma</strong>, we aim to partner with local schools for real change.
            </p>

            <blockquote className="founder-quote">
              “We believe that schools deserve more than just textbooks — they deserve a vision, a voice, and the right support.”
            </blockquote>

            <img src="/signature.png" alt="Signature" className="signature-img" /> {/* optional image */}
            <br />
            {/* <Button variant="warning" className="mt-4">See Our Vision</Button> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AboutSection;
